// Muss in den jeweiligen Modulen importiert werden mit:
// import rules from '@/store/rules'

export default {
	// STRING
	requiredRule: [
		(v: string) => !!v || "Angabe erforderlich. ",
		(v: string) =>
			!v || v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
	],
	optionalStringMax35Rule: [(v: string) => v.length <= 35 || "Maximal 35 Zeichen erlaubt."],
	requiredStringMax10Rule: [
		(v: string) => !!v || "Angabe erforderlich",
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
		(v: string) => !v || v.length <= 10 || "Maximal 10 Zeichen erlaubt.",
	],
	requiredStringMax35Rule: [
		(v: string) => !!v || "Angabe erforderlich",
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
		(v: string) => !v || v.length <= 35 || "Maximal 35 Zeichen erlaubt.",
	],
	requiredStringMax50Rule: [
		(v: string) => !!v || "Angabe erforderlich",
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
		(v: string) => !v || v.length <= 50 || "Maximal 50 Zeichen erlaubt.",
	],
	addressOptionalStringRule: [
		(v: string) =>
			!/[\*\^\\\{\}\[\]\=\>\<\|]/.test(v) ||
			'Enthält unerlaubte Zeichen \"* ^ \ { } [ ] = < > |\"',
	],
	addressRequiredStringRule: [
		(v: string) => !!v || "Angabe erforderlich",
		(v: string) =>
			!v || v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
		(v: string) =>
			!/[\*\^\\\{\}\[\]\=\>\<\|]/.test(v) ||
			'Enthält unerlaubte Zeichen \"* ^ \ { } [ ] = < > |\"',
	],
	// EMAIL
	requiredEmailRule: [
		(v: string) => !!v || "Angabe erforderlich. ",
		(v: string) => v.length <= 50 || "Maximal 50 Zeichen erlaubt. ",
		(v: string) =>
			/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) || "Muss eine gültige E-Mail Adresse sein. ",
	],
	optionalEmailRule: [
		(v: string) =>
			!v ||
			(v.indexOf("@") > 0 && v.indexOf("@") < v.length - 1) ||
			v.length <= 50 ||
			v.length === 0 ||
			"Muss eine gültige E-Mail Adresse sein. ",
	],
	// URL
	optionalUrlRule: [
		(v: string) =>
			!v ||
			/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/.test(
				v
			) ||
			"Muss eine gültige URL (mit http(s)) sein.",
	],
	// NUMBER
	requiredIntegerRule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: string) => parseInt(v) === parseFloat(v) || "Muss eine ganze Zahl sein.",
	],
	optionalIntegerRule: [
		(v: number) => !v || !isNaN(v) || "Muss eine Zahl sein.",
		(v: string) => !v || parseInt(v) === parseFloat(v) || "Muss eine ganze Zahl sein.",
	],
	requiredNonNegativeIntegerRule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: string) => parseInt(v) === parseFloat(v) || "Muss eine ganze Zahl sein.",
		(v: number) => v >= 0 || "Muss >= 0 sein.",
	],
	optionalNonNegativeIntegerRule: [
		(v: number) => !v || !isNaN(v) || "Muss eine Zahl sein.",
		(v: string) => !v || parseInt(v) === parseFloat(v) || "Muss eine ganze Zahl sein.",
		(v: number) => !v || v >= 0 || "Muss >= 0 sein.",
	],
	requiredInteger0To100Rule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: string) => parseInt(v) === parseFloat(v) || "Muss eine ganze Zahl sein.",
		(v: number) => v >= 0 || "Muss >= 0 sein.",
		(v: number) => v <= 100 || "Muss <= 100 sein.",
	],
	requiredNumberRule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
	],
	requiredNonNegativeNumberRule: [
		(v: number) =>
			(v !== null && v !== undefined && v.toString() !== "") || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => v >= 0 || "Muss >= 0 sein.",
	],
	requiredNumberBiggerZeroRule: [
		(v: number) => (v && !!v.toString()) || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => v > 0 || "Muss > 0 sein.",
	],
	optionalNonNegativeNumberRule: [
		(v: number) => !v || !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => !v || v >= 0 || "Muss >= 0 sein.",
	],
	requiredNumber0To1Rule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => v >= 0 || "Muss >= 0 sein.",
		(v: number) => v <= 1 || "Muss <= 1 sein.",
	],
	optionalNumber0To1Rule: [
		(v: number) => !v || !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => !v || v >= 0 || "Muss >= 0 sein.",
		(v: number) => !v || v <= 1 || "Muss <= 1 sein.",
	],
	requiredNumberBiggerEqual1Rule: [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => v >= 1 || "Muss >= 1 sein.",
	],
};
